import { login, logout } from "./authSlice";

import apiSlice from "../services/apiSlice";

export const profileApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        updateProfile: builder.mutation({
            query: (formData) => ({
                url: "/update-profile",
                method: "POST",
                body: formData,
                formData: true, // Important for multipart/form-data
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;

                    console.log("update profile response ", data);

                    const token = data.token || localStorage.getItem("token");

                    if (data.user) {
                        dispatch(login({ token, user: data.user }));
                    }
                } catch (err) {
                    console.error("Failed to update profile:", err);
                }
            },
        }),

        deleteAccount: builder.mutation({
            query: () => ({
                url: "/delete-account",
                method: "DELETE",
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled();
                    dispatch(logout());
                } catch (err) {
                    console.error("Failed to delete account:", err);
                }
            },
        }),
    }),
});

// Export hooks for use in components
export const {
    useUpdateProfileMutation,
    useDeleteAccountMutation,
} = profileApi;
